export default "__VITE_PUBLIC_ASSET__724a1378__"